import { format } from "date-fns";
import LibMask from "../../../util/mask";

export function noMes(dia, hora) {
	const hoje = new Date();
	const data = new Date(hoje.getFullYear(), hoje.getMonth(), Math.min(dia, hoje.getDate()));
	return `${format(data, "yyyy-MM-dd")}T${hora}:00`;
}

function contem(valor, termo) {
	return String(valor).toLowerCase().includes(termo.toLowerCase());
}

export function filtrar(lista, f, diaDe) {
	return lista.filter((item) => {
		const dia = diaDe(item).slice(0, 10);

		return (
			dia >= f.dtIni &&
			dia <= f.dtFim &&
			(!f.modelo || item.modelo === Number(f.modelo)) &&
			(!f.venda || String(item.id_venda) === f.venda) &&
			(!f.cliente || contem(item.cliente, f.cliente)) &&
			(!f.cpfCnpj || LibMask.onlynumbers(item.dest_cpfcnpj).includes(LibMask.onlynumbers(f.cpfCnpj))) &&
			(!f.status || item.status === f.status)
		);
	});
}
